export const escapeHTMLTags = (input: string) => input.replace(/<\/?[^>]+>/g, '');
